//This is the Backend Js code to fetch the data
var data = require("./final.json");

export default data